import React, { useEffect, useState } from "react";
import SectionTitle from "../../components/SectionTitle";
import SinglePost from "../../components/Blog/SinglePost";
import { Link } from "react-router-dom";
import { SERVER_URL } from "../../api/url";
import axios from "axios";
import { FaArrowRight } from "react-icons/fa";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/blog/get-for-home`);
      const fetchedBlogs = response.data?.data || [];
      setBlogs(fetchedBlogs);

    } catch (err) {
      console.error(err);

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="react-blog__area blog__area pt---100 pb---100 graybg-home">
      <div className="container blog__width">
        {!loading && blogs.length !== 0 && (
          <div>
            <SectionTitle Title="Your French Teachers News and Blogs" />
            <div className="row">
              {blogs.map((blog, index) => (
                <div
                  key={index}
                  className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 wow animate__fadeInUp"
                  data-wow-duration="0.3s"
                >
                  <SinglePost
                    blog={blog}

                  />
                </div>
              ))}
            </div>
            <Link
              to="/blog"
              rel="noopener noreferrer"
              style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}
              className=" bg-gray text-primary px-4 py-2 rounded hover:primary transition-colors"
            >
             Read More <FaArrowRight className="ml-2" />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
